import React, { useState } from 'react';
import CarouselComponent from './components/Header/CarouselComponent';
import Banner from './components/Header/Banner';
import Suggest from './components/Suggest';
import { useGetMoviesByLocationQuery } from './services/moviesData';
import { useSelector } from 'react-redux';
import Test from './components/NotUsing/Test';
//import LocationProvider from './components/LocationContext';
import LatestMovies from './components/LatestMovies';

function App() {
  const location = useSelector((state) => state.location.value);
  const { data } = useGetMoviesByLocationQuery(location);

  //let locations = ['New York', 'Las Vegas', 'Houston', 'Memphis', 'Rochester', 'Aurora', 'Austin', 'Chicago', 'San Antonio', 'Orlando', 'Miami', 'Madison', 'Indianapolis', 'Columbia', 'Dallas', 'San Francisco', 'Springfield', 'Columbus', 'Jacksonville', 'Atlanta', 'San Diego', 'Los Angeles', 'Minneapolis', 'Jamaica', 'Honolulu']
  
  const [SeeAllMovies, setSeeAllMovies] = useState(false)
 
  
  return (
   <div>
    
    <Banner SeeAll={setSeeAllMovies}/>
    <CarouselComponent/>
    {SeeAllMovies ? <LatestMovies location={location}/> : <Suggest data={data}/>}
     
      
    <Test/>


   </div>
   
  )
}

export default App;
